export const statusColor = (status: string) => {
  if (status === 'completed') return 'success'
  if (status === 'executable') return 'processing'
  if (status === 'created' || status === 'planned') return 'default'
  return 'warning'
}

export const formatAmount = (value: string | number | undefined) => {
  if (value === '' || value === undefined) return '-'

  const amount = Number(value)

  if (!Number.isFinite(amount)) return '-'

  return amount.toFixed(2)
}

export const formatPercent = (value: string | number | undefined) => {
  const amount = Number(value)

  if (!Number.isFinite(amount)) return '-'

  return `${amount}%`
}

export const formatDate = (value: string | number | undefined) => {
  if (!value) return '-'

  const numericValue = Number(value)
  const date = Number.isFinite(numericValue)
    ? new Date(numericValue)
    : new Date(value)

  if (Number.isNaN(date.getTime())) return '-'

  return date.toLocaleString()
}
